var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import ClaimsButton from '@declaration/components/UI/ClaimsButton.vue';
const layout = namespace('layout');
let BreakInDamageDescriptionStep = class BreakInDamageDescriptionStep extends Vue {
    get validationButtonText() {
        if (this.isFinalStep) {
            return this.$tc('claim.declaration.break_in_damages.form.validate');
        }
        return this.$tc('claim.declaration.break_in_damages.form.next-step');
    }
};
__decorate([
    layout.State('color')
], BreakInDamageDescriptionStep.prototype, "color", void 0);
BreakInDamageDescriptionStep = __decorate([
    Component({
        components: {
            ClaimsButton,
        },
        props: {
            isFinalStep: {
                type: Boolean,
                default: false,
            },
            isValid: {
                type: Boolean,
                default: false,
            },
            isSaving: {
                type: Boolean,
                default: false,
            },
            save: {
                type: Function,
                required: true,
            },
            revealValidation: {
                type: Function,
                required: true,
            },
        },
    })
], BreakInDamageDescriptionStep);
export default BreakInDamageDescriptionStep;
